import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class FechasCupo {
  static obtenerFechaDeEmisionDefault () {
    const axios = getAxiosInstance()
    const promise = axios.get(`fecha_de_emision_default`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static obtenerFechaConsumoCupo (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`fecha_consumo_cupo?r=` +
        `{"parametros": {"cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result })
  }
}

export default FechasCupo
